import React from 'react';
import { useTranslation } from 'react-i18next';
import { KoobTooltip } from '@koob/ui';

export interface FolderReadOnlyTooltipProps {
  readOnly: boolean;
  children: React.ReactElement;
}

/**
 * KD-3842: explains why an action is disabled on an archived folder. A
 * disabled button swallows pointer events, so the tooltip sits on a wrapper.
 */
export default function FolderReadOnlyTooltip({
  readOnly,
  children,
}: FolderReadOnlyTooltipProps) {
  const { t } = useTranslation('folders');

  if (!readOnly) {
    return children;
  }

  return (
    <KoobTooltip tip={t('actions.readOnlyHint')}>
      <span className="inline-flex">{children}</span>
    </KoobTooltip>
  );
}
